import React, { useState } from 'react';
import { ButtonField, InputField, SelectField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem } from '@wk/components-react16';
import { API_ACTIVITY } from '../../core/constants';
import Api from '../../core/api';
import { Toast } from '../../services';
import FileSaver from 'file-saver';

const ExportActivityLog = ({ isOpen, setIsOpen }: any) => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpen(false);
        }
    }

    const handleExportReport = async () => {
        Api.getRequestBlob(`${API_ACTIVITY.GET_ACTIVITY}?start=${startDate}&end=${endDate}`).then(
            (res: any) => {
                const fileName = 'User-activity-log-' + startDate + '-to-' + endDate + '.csv';
                FileSaver.saveAs(
                    new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
                    fileName,
                )
                setIsOpen(false);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <>
            <Modal
                isOpen={isOpen}
                srLabelledBy={'modal-id-006'}
                srDescribedBy={'modal-id-007'}
                width={'400px'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-006'}
                    isFullscreenButtonVisible
                    onUserRequest={() => handleUserRequest('header')}>
                    Export User Activity Report{' '}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-007">
                    <div className="flex">
                        <span className='mr-10'>
                            <InputField label="Start Date" labelFor="input-id-6">
                                <input
                                    type="date"
                                    id="input-id-6"
                                    name="startDate"
                                    className='mr-10'
                                    value={startDate}
                                    onChange={(e: any) => setStartDate(e.target.value)}
                                    max={endDate}
                                />
                            </InputField>
                        </span>
                        <InputField label="End Date" labelFor="input-id-7">
                            <input
                                type="date"
                                id="input-id-7"
                                name="endDate"
                                value={endDate}
                                onChange={(e: any) => setEndDate(e.target.value)}
                                min={startDate}
                            />
                        </InputField>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'text'}>
                                <button type="button" id="cancel" onClick={() => handleUserRequest('header')}>
                                    Cancel
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'}>
                                <button type="button" disabled={!startDate || !endDate} onClick={() => handleExportReport()}>
                                    Export Report
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal >
        </>
    );
};

export default ExportActivityLog;
